
import Vue, { PropType } from 'vue'

export type DataType = {
  timerId?: number;
}

export default Vue.extend({
  name: 'BasePager',

  props: {
    totalPage: Number as PropType<number>,
    currentPage: Number as PropType<number>,
  },

  computed: {
    canShow(): boolean {
      return this.totalPage > 1
    },

    isFirst(): boolean {
      return this.currentPage === 1
    },

    isLast(): boolean {
      return this.currentPage === this.totalPage
    },

    prevMaxTwo(): number[] {
      const res: number[] = []
      for (let i = this.currentPage - 1; i > this.currentPage - 3; i--) {
        if (i > 0) res.push(i)
      }
      return res.reverse()
    },

    nextMaxTwo(): number[] {
      const res: number[] = []
      for (let i = this.currentPage + 1; i <= this.currentPage + 2; i++) {
        if (i <= this.totalPage ) res.push(i)
      }
      return res
    },

    needsFirst(): boolean {
      return !this.isFirst && !this.prevMaxTwo.includes(1)
    },

    needsLast(): boolean {
      return !this.isLast && !this.nextMaxTwo.includes(this.totalPage)
    },

    hasMoreThanThreePrev(): boolean {
      return this.currentPage - 2 >= 3
    },

    hasMoreThanThreeNext(): boolean {
      return (this.totalPage - this.currentPage) >= 3
    },
  },

  methods: {
    isCurrent(page: number): boolean {
      return page === this.currentPage
    },

    emitChangePage(page: number): void {
      this.$emit('change-page', page)
    }
  }
})
